import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(menu)/menu")({
  component: MenuLayout,
});

function MenuLayout() {
  return <Outlet />;
}